import React from 'react';
import './cargando.scss'
import { connect } from "react-redux"; 	

const mapStateToProps = state => {
  return { 
		mensaje: state.cargando.mensaje,
		progreso: state.cargando.progreso,
	};
};

function CargandoConnected(props){
	const style = {width:props.progreso+"%"};
	return(
		<div id="cargando" className={props.progreso>=100?"hide":"show"}>
			<div className="popup">
				<p>Cargando</p>
				<div className="texto">{props.mensaje}</div>
				<div className="barra">
					<div className="progreso" style={style}>
					</div>
				</div>
			</div>
		</div>
	);
}

const ModalCargando = connect(mapStateToProps) (CargandoConnected);
export default ModalCargando;